import ScrollMagic from 'scrollmagic';
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';

export default {
    init: function () {
        (function () {
            var $carouselElem = $('.timeline__carousel');
            var historyItems = document.querySelectorAll(".history-meta__milestone");
            var smController = new ScrollMagic.Controller();

            // The legacy layout wrapped the page in `.body__wrap`, which had
            // overflow:hidden and broke position:sticky. app has no such
            // wrapper, so the override it used to need is gone.

            $carouselElem.slick({
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: "linear",
                arrows: false,
                waitForAnimate: false,
                swipe: "false",
                swipeToSlide: false,
                touchMove: false,
                draggable: false,
                accessibility: false,
            });

            for (var i = 0; i < historyItems.length; i++) {
                var element = historyItems[i];
                new ScrollMagic.Scene({
                    triggerElement: element,
                    triggerHook: 0.5,
                    duration: "100%",
                }).on("start", function (e) {
                    goToSlide($(e.target.triggerElement()).attr("data-slide"));
                }).addTo(smController);
            }

            if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1){
                /**
                 * IE Fallback
                 */
                var timelineContainer = document.querySelector(".timeline__outer");
                var windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;

                timelineContainer.classList.remove("native-sticky");
                timelineContainer.classList.add("fallback-sticky");

                new StickySidebar('.timeline__outer', {
                    containerSelector: ".timeline",
                    topSpacing: (windowHeight / 5),
                });
            }

            function goToSlide(idx) {
                $carouselElem.slick("slickGoTo", idx);
            }
        })();
    },
    finalize() {

    },
}
